import React from 'react'

import Stepper from 'Molecules/Stepper'

function activeDataTestId(shipmentStep, stepperStep) {
  return stepperStep <= (shipmentStep ?? 0) ? '_active' : ''
}

function getActiveStep(displayPackageStatus) {
  switch (displayPackageStatus?.toLowerCase()) {
    case 'ordered':
      return 0
    case 'shipped':
      return 1
    case 'on the way':
    case 'ready for pickup':
      return 2
    case 'out for delivery':
    case 'picked up':
      return 3
    case 'delivered':
      return 4
    default:
      return -1
  }
}

function getPackageSteps(shipment, activeStep) {
  const baseSteps = [
    {
      svg: 'check',
      dataTestId: `ordered${activeDataTestId(activeStep, 0)}`,
    },
    {
      svg: 'in_store_pickup',
      dataTestId: `packed${activeDataTestId(activeStep, 1)}`,
    },
  ]

  const additionalSteps = shipment.isInStore
    ? [
        {
          svg: 'box',
          dataTestId: `readyForPickup${activeDataTestId(activeStep, 2)}`,
        },
        {
          svg: 'made_to_order',
          dataTestId: `pickedUp${activeDataTestId(activeStep, 3)}`,
        },
      ]
    : [
        {
          svg: 'fast_shipping',
          dataTestId: `shipped${activeDataTestId(activeStep, 2)}`,
        },
        {
          svg: 'box',
          dataTestId: `outForDelivery${activeDataTestId(activeStep, 3)}`,
        },
        {
          svg: 'made_to_order',
          dataTestId: `delivered${activeDataTestId(activeStep, 4)}`,
        },
      ]

  return baseSteps.concat(additionalSteps)
}

const OrderSummaryShipmentStepper = ({ order, shipment }) => {
  if (shipment.displayPackageStatus === 'Cancelled') return false

  var activeStep = getActiveStep(shipment.displayPackageStatus)
  var steps = getPackageSteps(shipment, activeStep)

  return (
    <Stepper
      intent="positive"
      stepperDataTestId={`${order.orderNumber}_${shipment?.trackingNumber ?? 'unshipped'}`}
      steps={steps}
      size={1}
      activeStepWrapper={{
        activeStep: activeStep,
        activeStepIntent: (!shipment.deliveryDate && shipment.isDelayed) || order.isOnHold ? 'warning' : 'positive',
      }}
    />
  )
}

export default OrderSummaryShipmentStepper
